import { Component, PropsWithChildren, ReactNode } from 'react'
import { t } from 'i18next'

interface ErrorBoundaryState {
  error: Error | null
}

export default class ErrorBoundary extends Component<
  Readonly<PropsWithChildren>,
  ErrorBoundaryState
> {
  constructor(props: Readonly<PropsWithChildren>) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error }
  }

  render(): ReactNode {
    const { error } = this.state
    const { children } = this.props

    if (error) {
      return (
        <div
          style={{
            margin: '20px',
            padding: '10px',
            border: '1px solid red',
            borderRadius: '5px'
          }}
        >
          <h1>{t('ui-common:error.renderError.title')}</h1>
          <p>{t('ui-common:error.renderError.message')}</p>
          <pre>
            {error.name}
            {error.stack}
          </pre>
        </div>
      ) as ReactNode
    }

    return children
  }
}
